import type { ReactNode } from 'react'

import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'

type MentionChipProps = {
  label: ReactNode
  tooltip: string
}

export const MentionChip = ({ label, tooltip }: MentionChipProps) => (
  <Tooltip
    asChild
    triggerClassName='inline'
    trigger={
      <span className='cursor-default font-medium text-main-foreground-accent'>@{label}</span>
    }
  >
    {tooltip}
  </Tooltip>
)
